/* eslint-disable no-shadow */
import React from 'react';
import { StyleSheet, Text, TouchableOpacity } from 'react-native';
import Button from '../../components/UI/Button';
import { BERRY, BEIGE } from '../../settings/colors';
import LabeledTextInput from '../../components/inputs/LabeledTextInput';
import Card from '../../components/cards/Card';
import validator from 'email-validator';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { requestVerificationCode } from '../../store/actions/auth';
import { H1 } from '../../components/UI/TextStyles';
import AuthLayout from '../../components/layouts/AuthLayout.web';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: BEIGE,
    justifyContent: 'center',
    alignItems: 'center',
  },
  logo: { width: 100, height: 40, margin: 40 },
  text: {
    textAlign: 'center',
  },
  marginRight: {
    marginRight: 10,
  },
});

function Registration() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [error, setError] = React.useState(null);
  const [isLoading, setLoading] = React.useState(false);
  const [user, setUser] = React.useState({
    email: '',
    firstName: '',
    lastName: '',
    gender: '',
    birthYear: '',
  });
  const { firstName, lastName, birthYear, email, gender } = user;
  return (
    <AuthLayout>
      <Card>
        <H1 centered>Erstelle dein Konto.</H1>
        {error && <Text style={{ color: 'red' }}>{error}</Text>}
        <LabeledTextInput
          placeholder="Vorname"
          value={firstName}
          onChangeText={firstName => setUser({ ...user, firstName })}
        />
        <LabeledTextInput
          placeholder="Nachname"
          value={lastName}
          onChangeText={lastName => setUser({ ...user, lastName })}
        />
        <LabeledTextInput
          placeholder="E-Mail-Adresse"
          value={email}
          onChangeText={email => setUser({ ...user, email })}
        />
        <LabeledTextInput
          placeholder="Jahrgang"
          value={birthYear}
          onChangeText={birthYear => setUser({ ...user, birthYear })}
          minLength={4}
          maxLength={4}
        />
        <select
          style={{ fontSize: '17px', marginTop: '20px', marginBottom: '20px' }}
          name="gender"
          onChange={e => setUser({ ...user, gender: e.target.value })}
        >
          <option value="">Geschlecht</option>
          <option value="female">Weiblich</option>
          <option value="male">Männlich</option>
        </select>
        <Button
          style={{ marginTop: 20 }}
          text="Weiter"
          type="primary"
          size="large"
          action={async () => {
            if (!validator.validate(user.email)) {
              return setError(
                'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
              );
            }
            setLoading(true);
            const codeSent = await dispatch(
              requestVerificationCode(user.email, 'registration'),
            ).catch(e => {
              setError(e.message);
              return null;
            });
            setLoading(false);
            if (codeSent) {
              return history.push('/verify', {
                identifier: email,
                type: 'email',
                firstName,
                lastName,
                gender,
                birthYear,
                action: 'registration',
              });
            }
          }}
          isLoading={isLoading}
          disabled={!firstName || !lastName || !birthYear || !email || !gender}
        />
      </Card>
      <TouchableOpacity onPress={() => history.push('/login')}>
        <Text style={[styles.text, { color: BERRY }]}>
          Hast du schon ein Konto?
        </Text>
      </TouchableOpacity>
    </AuthLayout>
  );
}

export default Registration;
